<template>
<div class="container">
<b-row >
<b-container>
	<h3 ><b><i>{{f_titulo_orden_compra()}}</i></b></h3>
	<h4>
	<label>País</label>
	<select v-model="pais" @click="f_seleccione_proveedores()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
	<h5><b-row>
		<b-col cols="6" class="text-center">
			<button class="md-primary" @click="muestreDetalleOrden=true">CREAR</button>
		</b-col>
		<b-col cols="6" class="text-center">
			<button class="md-primary" @click="f_consulta_manuales">CONSULTAR</button>
		</b-col>
		</b-row></h5>

<md-dialog :md-active.sync="muestreDetalleOrden">
	<md-dialog-content>
		<md-table >
			<b-row >
				<b-col md="7" lg="auto" class="mt-2 mx-auto">
					<b-form id="create-form">
						<b-row class="mt-3">
							<b-col cols="3" class="text-left">
								<h5>Orden Compra</h5>
							</b-col>
							<b-col cols="3" class="text-left">
								<input type="number" v-model="ordenCompra.orden_compra" class="form-control">
							</b-col>
							<b-col cols="2" class="text-left">
								<h5>Fecha</h5>
							</b-col>
							<b-col cols="4" class="text-left">
								<input type="date" v-model="ordenCompra.fecha" class="form-control">
							</b-col>
						</b-row>
						<b-row class="mt-3 justify-content-center">
							<b-col cols="3" class="text-left">
								<h5>Proveedor</h5>
							</b-col>
							<b-col cols="9" class="justify-content-center">
								<select class="form-control" v-model="ordenCompra.proveedor" @click="f_seleccione_productos">
									<option value="" default>Seleccionar.....</option>
									<option v-for="proveedores in listProveedores" :key="proveedores.identificacion" :value="proveedores.identificacion">{{ proveedores.nombre }}</option>
								</select>
							</b-col>
						</b-row>
						<b-row class="mt-3">
							<b-col cols="3" class="text-left">
								<h5>Items</h5>
							</b-col>
							<b-col cols="3" class="text-left">
								<input type="number" v-model="ordenCompra.items" class="form-control" readonly>
							</b-col>
							<b-col cols="2" class="text-left">
								<h5>Total</h5>
							</b-col>
							<b-col cols="4" class="text-left">
								<input type="number" v-model="ordenCompra.total" class="form-control" readonly>
							</b-col>
						</b-row>
					</b-form>
				</b-col>
			</b-row >
			<b-row v-if="ordenCompra.items>0">
				<b-col>
				<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-primary" @click="creaOrden()">
					Guardar
				</md-button>
				</b-col>
				<b-col>
				<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-primary" @click="cierreOrden()">
					Cancelar
				</md-button>
				</b-col>
			</b-row >
		</md-table>
		<div class="row col-md-12 justify-content-center " v-if="listItemsOrden.length != 0">
			<b-table
				:items="listItemsOrden"
				:fields="fields"
				hover
				bordered
				responsive
				sticky-header="500px"
				small
				class="tblEstandar"
				head-variant="custom-blue"
				@row-clicked="(item) => tipoModificacion(item.id)"
			>
			<template #cell(material)="data">
				<div class="text-left">{{ data.item.material }}</div>
			</template>
			<template #cell(descripcion)="data">
				<div class="text-left">{{ data.item.descripcion }}</div>
			</template>
			<template #cell(cantidad)="data">
				<div class="text-center">{{ data.item.cantidad }}</div>
			</template>
			<template #cell(moneda)="data">
				<div class="text-center">{{ data.item.moneda }}</div>
			</template>
			<template #cell(unidad)="data">
				<div class="text-center">{{ data.item.unidad }}</div>
			</template>
			<template #cell(monto_neto)="data">
				<div class="text-right">{{ formatNumber(data.item.monto_neto) }}</div>
			</template>
			<template #cell(precio_neto)="data">
				<div class="text-right">{{ formatNumber(data.item.precio_neto) }}</div>
			</template>
			</b-table>
		</div>
		<md-table v-if="ordenCompra.proveedor!=''">
			<b-row>
				<b-col md="7" lg="auto" class="mt-2 mx-auto">
					<b-form id="create-form">
						<b-row class="mt-3">
							<b-col cols="5" class="text-left">
								<select class="form-control" v-model="ordenCompra.material">
									<option value="">Seleccionar.....</option>
									<option v-for="productos in listProductos" :key="productos.id" :value="productos.referencia_proveedor+'-'+productos.descripcion_proveedor">{{ productos.referencia_proveedor}}-{{productos.descripcion_proveedor}}</option>
								</select>
							</b-col>
							<b-col cols="1" class="text-left">
								<input type="number" v-model="ordenCompra.cantidad" class="form-control" @blur="f_actualiza_precio_neto">
							</b-col>
							<b-col cols="1" class="text-left">
								<input type="text" v-model="ordenCompra.unidad" class="form-control">
							</b-col>
							<b-col cols="1" class="text-left">
								<input type="number" v-model="ordenCompra.monto_neto" class="form-control" @blur="f_actualiza_precio_neto">
							</b-col>
							<b-col cols="1" class="text-left">
								<input type="number" v-model="ordenCompra.precio_neto" class="form-control" placeholder="Total" readonly>
							</b-col>
							<b-col cols="1" class="text-left">
								<input type="text" v-model="ordenCompra.moneda" class="form-control" placeholder="Moneda">
							</b-col>
							<b-col cols="1" class="text-left">
								<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="creaItem(ordenCompra)">
									<md-icon>add</md-icon>
								</md-button>
							</b-col>
						</b-row>
					</b-form>
				</b-col>
			</b-row>
		</md-table>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="muestreConsultaOrden">
	<md-dialog-content>
		<md-dialog-title class="text-center">
		<h3 ><b><i>{{f_titulo_orden_compra()}}-CONSULTA</i></b></h3>
		</md-dialog-title>
		<div class="row col-md-12 justify-content-center " v-if="listOrdenCompra.length != 0">
			<b-table
				:items="listOrdenCompra"
				:fields="fields"
				hover
				bordered
				responsive
				sticky-header="500px"
				small
				class="tblEstandar"
				head-variant="custom-blue"
				@row-clicked="(item) => tipoModificacion(item.id)"
			>
			<template #cell(orden_compra)="data">
				<div class="text-left">{{ data.item.orden_compra }}</div>
			</template>
			<template #cell(descripcion)="data">
				<div class="text-left">{{ data.item.descripcion }}</div>
			</template>
			<template #cell(fecha)="data">
				<div class="text-center">{{ data.item.fecha }}</div>
			</template>
			<template #cell(cuantos)="data">
				<div class="text-center">{{ data.item.cuantos }}</div>
			</template>
			<template #cell(precio_neto)="data">
				<div class="text-right">{{ formatNumber(data.item.precio_neto) }}</div>
			</template>
			</b-table>
		</div>
	</md-dialog-content>
</md-dialog>
</b-container>

</b-row>
</div>
</template>
<script>
import Factura from "@/services/Facturas"
import User from "@/services/User"
import Razon from "@/services/Razones"
import Estado from "@/services/Estados"

export default {
name:'Facturas',
data: () => ({
	users : [],
	listPaises : [],
	listRazones : [],
	listRazonesLeidas : [],
	listEstados : [],
	listProveedores : [],
	listProductos : [],
	listItemsOrden : [],
	listOrdenCompra : [],
	pais : '',
	muestreDetalleOrden: false,
	muestreConsultaOrden: false,
	ordenCompra: { proveedor:''},
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			documento : "Tipo",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad_facturas : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto_tot : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			item : "Item",
			descripcion : "Descripcion",
			precioFE : "PrecioFE",
			precioSAP : "PrecioSAP",
			cantidadFE : "CantFE",
			cantidadSAP : "CantSAP",
			ivaFE : "IvaFE",
			ivaSAP : "IvaSAP",
			impuestoFE : "ImpFE",
			impuestoSAP : "ImpSAP",
			diferencia_total : "DifTotal",
			valor_fe : "TotalFE",
			valor_sap : "TotalSAP",
			usuario : "Usuario",
			cantidad: "Cantidad",
			codigo: "Codido",
			descripcion_item: "Descripcion Producto --------------------------------",
			descripcion_item_orden: "Descripcion Orden Compra ----------------------------------------------",
			descripcion_novedad: "Descripcion ----------------------------------------------------------------------------------------",
			unidad: "UnEmpa",
			unitario: "Monto",
			venta_bruta: "Precio Ord",
			venta_bruta_factura: "Precio Fac",
			item_factura: "Item Fac",
			impuesto: "Impuesto",
			cantidad_facturada: "Cant Fac",
			precio_facturado: "Precio Fac",
			valoresQ: "Q SAP",
			valoresP: "P SAP",
			diferenciasQ: "DIFER Q",
			diferenciasP: "DIFER P",
			monto_facturado: "Monto Fac",
			iva: "IGV",
			otroImpuesto : "Imp Adic",
			estado: "Estado",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			item : "Item",
			descripcion : "Description",
			diferencia_precio : "Price Dif",
			diferencia_cantidad : "Amount Dif",
			diferencia_iva : "Iva Dif",
			diferencia_impuesto : "Other Tax Dif",
			diferencia_Total : "Total",
			diferencia_total : "Total Dif",
			valor_fe : "FE Value",
			valor_sap : "SAP Value",
		}
	}
}
},
mounted(){

	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
        Razon.leaRazones()
        .then((res) => {
            this.listRazonesLeidas = res.data.listRazones
        })
        .catch((err) => {
            console.log(err)
        })
        Estado.leaEstados(false)
        .then((res) => {
            this.listEstados = res.data.listEstados
        })
        .catch((err) => {
            console.log(err)
        })
        Factura.leaPaises(false)
        .then((res) => {
            this.listPaises = res.data.listPaises
        })
        .catch((err) => {
            console.log(err)
        })

},
methods:{
	f_titulo_orden_compra() {
		return "ORDENES DE COMPRA "
	},
	f_seleccione_proveedores() {
		Factura.leaProv(this.pais)
		.then((res) => {
			this.listProveedores = res.data.listProveedores
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_seleccione_productos() {
		Factura.leaProductos(this.pais,this.ordenCompra.proveedor)
		.then((res) => {
			this.listProductos = res.data.listProductos
		})
		.catch((err) => {
			console.log(err)
		})
	},
	creaItem(r_item) {
		if	(r_item.material == "") {
			return
		}
		let itemOrden = {
			material: r_item.material,
			cantidad: r_item.cantidad,
			unidad: r_item.unidad,
			monto_neto: r_item.monto_neto,
			precio_neto: r_item.precio_neto,
			moneda: r_item.moneda
		}
		var v_items = 0
		var v_total = 0.0
		this.listItemsOrden.push(itemOrden)
		this.listItemsOrden.forEach((item) => {
			v_items+=1
			v_total+=parseFloat(item.precio_neto)
		})
		this.ordenCompra.items=v_items
		this.ordenCompra.total=v_total
		this.ordenCompra.material=''
		this.ordenCompra.cantidad=''
		this.ordenCompra.unidad=''
		this.ordenCompra.monto_neto=''
		this.ordenCompra.precio_neto=''
	},
	formatNumber(value) {
		return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
	}, 	
	creaOrden() {
		const v_proveedor = this.listProveedores.filter((proveedor) => proveedor.identificacion === this.ordenCompra.proveedor)
		this.ordenCompra.nombre_proveedor = v_proveedor[0].nombre
		const info = {
			pais : this.pais,
			orden : this.ordenCompra,
			items : this.listItemsOrden
		}
		Factura.grabaOrdenManual(info)
		.then((res) => {
			this.$toast.success(res.data.message)
		})

		this.muestreDetalleOrden=false
		this.ordenCompra={ proveedor:""}
		this.listItemsOrden = []
	},
	cierreOrden() {
		this.muestreDetalleOrden=false
		this.ordenCompra={ proveedor:""}
		this.listItemsOrden = []
	},
	f_actualiza_precio_neto(){
		if	(this.ordenCompra.cantidad != '' && this.ordenCompra.monto_neto != '') {
			this.ordenCompra.precio_neto = parseFloat(this.ordenCompra.cantidad) *
				parseFloat(this.ordenCompra.monto_neto)
		}
	},
	f_consulta_manuales() {
		Factura.consultaOrdenesManuales(this.pais)
		.then((res) => {
			this.listOrdenCompra = res.data.listOrdenCompra
			this.muestreConsultaOrden=true
		})
		.catch((err) => {
			console.log(err)
		})
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}
.md-dialog::-webkit-scrollbar {
	width: 50px; /* Ancho de la barra de desplazamiento */
}
</style>
